import API from '../util/API';
import { ApiError } from './ApiError';

import { IArenaPart, IArenaRevision } from '../types';

export const getArenaPart = async (authToken: string, partNumber: string): Promise<IArenaPart> => {

  const result = await API.get(authToken, `/api/v1/part/${partNumber}`, { timeout: 3500 })
    .catch(err => { throw new ApiError('Arena part error', 404, `Unable to get part ${partNumber} (${err.message})`) });
  if (result) {
    return result.data as IArenaPart;
  }
  throw new ApiError('Arena part error', 400, `Unable to get part ${partNumber}})`);
}

export const getArenaPartRevisions = async (authToken: string, partNumber: string): Promise<IArenaRevision[]> => {

  const result = await API.get(authToken, `/api/v1/part/${partNumber}/revisions`, { timeout: 3500 })
    .catch(err => { throw new ApiError('Arena revision error', 404, `Unable to get revisions for  ${partNumber} (${err.message})`) });
  if (result) {
    const revisions = result.data as IArenaRevision[];
    return revisions.sort((a, b) => a.number < b.number ? 1 : -1);
  }
  throw new ApiError('Arena part error', 400, `Unable to get revisions for ${partNumber}})`);
}
